import { BigMath } from "@yn/utils";

interface GetSellMaxSharesParams {
    recordNo?: string | null;
    maxSellQty?: number | null;
    selectedOption: "yes" | "no";
    userContractsInfo: any;
}

function toPositiveNumber( value: unknown ) {
    const numericValue = Number( value ?? 0 );
    if ( !Number.isFinite( numericValue ) || !BigMath.gt( numericValue, 0 ) ) {
        return 0;
    }
    return numericValue;
}

function getOptionQuantity(
    userContractsInfo: any,
    selectedOption: "yes" | "no",
    fields: { yes: string[]; no: string[] },
) {
    const fieldNames = selectedOption === "yes" ? fields.yes : fields.no;

    for ( const fieldName of fieldNames ) {
        const quantity = toPositiveNumber( userContractsInfo?.[fieldName] );
        if ( BigMath.gt( quantity, 0 ) ) {
            return quantity;
        }
    }

    return 0;
}

export function getSellMaxShares(
    { recordNo, maxSellQty, selectedOption, userContractsInfo }: GetSellMaxSharesParams,
) {
    if ( recordNo && maxSellQty !== null && maxSellQty !== undefined ) {
        return toPositiveNumber( maxSellQty );
    }

    return getOptionQuantity( userContractsInfo, selectedOption, { yes: [ "yesQuantity" ], no: [ "noQuantity" ] } );
}

export function getMarketSellMaxShares(
    { recordNo, maxSellQty, selectedOption, userContractsInfo }: GetSellMaxSharesParams,
) {
    if ( recordNo && maxSellQty !== null && maxSellQty !== undefined ) {
        return toPositiveNumber( maxSellQty );
    }

    return getOptionQuantity( userContractsInfo, selectedOption, {
        yes: [ "yesSharesAmount", "yesQuantity" ],
        no: [ "noSharesAmount", "noQuantity" ],
    } );
}
